import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import InboxTicketListPage from 'modules/ticketing/public/InboxTicketListPage'

const TicketingPage = () => {
  const { has_dev_inbox_ticketing_tabs, loadingFeatures } = useFeatures([
    'dev_inbox_ticketing_tabs',
  ])

  if (loadingFeatures) return <Loading />
  if (!has_dev_inbox_ticketing_tabs) return <NotFound />

  return <InboxTicketListPage />
}

export default TicketingPage
